export const handleNewDeliveryMenuItemOnClick = (setSideBarMenuState , navigate) => {
    updateMenuItemState(setSideBarMenuState, 'newDeliveryItem')
    navigate.push('/new/booking')
    return
}

export const handleDeliveriesMenuItemOnClick = (setSideBarMenuState , navigate) => {
    updateMenuItemState(setSideBarMenuState,'deliveriesItem')
    navigate.push('/new/deliveries')
    return
}

export const handleDashboardMenuItemOnClick = (setSideBarMenuState , navigate) => {
    updateMenuItemState(setSideBarMenuState, 'dashboardItem')
    navigate.push('/new/dashboard')
    return
}

export const handleSupportItemOnClick = (setSideBarMenuState) => {
    updateMenuItemState(setSideBarMenuState, 'supportItem')
    return
}

const updateMenuItemState = (setSideBarMenuState , menuItem) => {
    setSideBarMenuState((previousState) => {
        let newState = {...previousState}
        for(let key in newState) {
            if (key === menuItem) {
                newState[`${key}`] = true
            } else {
                newState[`${key}`] = false
            }
        }
        return newState
    })
}